// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import styles from "./buSettings.scss";
import {
  ticketDashboardRouteObject,
  isAuthorized
} from "../ticketDashboard/ticketDashboardHelper";
import {
  buSettingsSubmit,
  getTicketingUsers
} from "./buSettingsRedux/buSettingsActionCreator";
import SelectWithAdd from "../../../commons/formElements/selectWithAdd/selectWithAdd";
import { navigateToRouteHelper } from "../../../../services/helpers";
import { setPageName } from "../../../../services/pageService/pageActionCreator";

type Props = {
  buSettingsState: Object,
  setPageName: Function,
  buSettingsSubmit: Function,
  getTicketingUsers: Function,
  userProfile: Object
};

type State = {
  selectedPermission: Object,
  emailList: Array<any>
};

const pageObj = {
  pageName: "Business Unit Settings"
};

class BUSettings extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      selectedPermission: null,
      emailList: []
    };
  }

  componentDidMount() {
    this.props.setPageName(pageObj);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.buSettingsState.buSettings.isLoading &&
      nextProps.buSettingsState.buSettings.isLoaded
    ) {
      if (nextProps.buSettingsState.buSettings.data) {
        toastr.success("Access updated successfully");
        navigateToRouteHelper(ticketDashboardRouteObject);
      } else {
        toastr.error("Updating access failed");
      }
    }
  }

  onChangeInput(val) {
    this.props.getTicketingUsers(val || "");
  }

  onSelectEmail(val) {
    this.setState({
      emailList: val
    });
    // eslint-disable-next-line
    console.log("Selected Value: ", val);
  }

  onSubmitSettings() {
    if (!this.state.selectedPermission) {
      toastr.error("Please select permission");
      return;
    }
    if (!this.state.emailList || !this.state.emailList.length) {
      toastr.error("Please select users");
      return;
    }
    const formData = {
      userEmailList: this.state.emailList,
      permission: this.state.selectedPermission.key
    };
    this.props.buSettingsSubmit(formData);
  }

  getPermissionOptions() {
    const arrayToReturn = [];
    if (
      isAuthorized(this.props.userProfile, [
        "ROLE_EDIT_TICKET_CE",
        "ROLE_MANAGE_BUSINESS_UNIT"
      ])
    ) {
      arrayToReturn.push({
        key: "category_manager",
        label: "Category Manager"
      });
    }
    arrayToReturn.push({
      key: "resolver_group_manager",
      label: "Resolver Group Manager"
    });
    return arrayToReturn;
  }

  getTicketingUsersSelectOptions(assigneeOptions) {
    const tableData = [];
    if (assigneeOptions.data) {
      if (assigneeOptions.data) {
        assigneeOptions.data.forEach(user => {
          tableData.push({
            key: user.name ? `${user.name} ${user.email}` : user.email,
            val: user.name ? user.email : user.name
          });
        });
      }
    }
    return tableData;
  }

  renderForm() {
    return (
      <Select
        autoFocus
        options={this.getPermissionOptions()}
        clearable={true}
        name="selected-state"
        disabled={false}
        value={this.state.selectedPermission}
        onChange={newValue =>
          this.setState({
            selectedPermission: newValue
          })
        }
        placeholder="Select permission"
        searchable={true}
      />
    );
  }

  render() {
    return (
      <div>
        <div className={`${styles.initialUtilityBar}`}>
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className="flex-15">
              <h2>Permission*</h2>
            </div>
          </div>
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className={`${styles.select}`}>{this.renderForm()}</div>
          </div>
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className="flex-15">
              <h2>Give access to create categories/group*</h2>
            </div>
          </div>
          <div className={`${styles.utilityBar} l-row a-center`}>
            <div className={`${styles.select}`}>
              <SelectWithAdd
                placeholder="Enter email id"
                options={this.getTicketingUsersSelectOptions(
                  this.props.buSettingsState.ticketingUsers
                )}
                onSelectOption={emailList => {
                  this.onSelectEmail(emailList);
                }}
                onChangeInput={val => this.onChangeInput(val)}
              />
            </div>
          </div>
        </div>
        <div
          className={`${styles.btnWrapper} l-row a-center`}
          onClick={() => this.onSubmitSettings()}
        >
          <div>
            <div className={`${styles.btnTextWrapper} j-center a-center`}>
              Submit
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  buSettingsState: state.buSettingsState,
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  buSettingsSubmit: bindActionCreators(buSettingsSubmit, dispatch),
  getTicketingUsers: bindActionCreators(getTicketingUsers, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(BUSettings);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/buSettings/buSettings.js